import { render, staticRenderFns } from "./SupplierListing.vue?vue&type=template&id=74667f05&"
import script from "./SupplierListing.vue?vue&type=script&lang=js&"
export * from "./SupplierListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports